import { render, staticRenderFns } from "./aws-translate.vue?vue&type=template&id=107c3158&"
import script from "./aws-translate.vue?vue&type=script&lang=js&"
export * from "./aws-translate.vue?vue&type=script&lang=js&"
import style0 from "./aws-translate.vue?vue&type=style&index=0&id=107c3158&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports